































































































import { GroupManagementGroupDTO } from "@/common/api";
import { AppVersion } from "@/common/utils";
import { Vue, Component, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const auth = namespace("Auth");

@Component({
  name: "QNav",
  components: {},
})
export default class QNav extends Vue {
  groupId = "";
  @auth.Getter
  getGroupUsers!: GroupManagementGroupDTO[];
  @auth.Getter
  getUsingGroup!: string;
  @auth.Action
  updateUsingGroup;
  @auth.Action
  logout;

  public appVersion = AppVersion();

  mounted() {
    this.groupId = this.getUsingGroup;
  }

  @Watch("getUsingGroup")
  changeGetUsingGroup() {
    this.groupId = this.getUsingGroup;
    this.changeUsingGroup();
  }

  changeUsingGroup() {
    this.updateUsingGroup(this.groupId);
    // reload
    window.location.href = this.$router.resolve("/admin/info").href;
  }
}
